module.exports = __webpack_public_path__ + "static/media/traffic_yellow.fecd8b23.png";